<div class="card height-100">

    <!--    Shipment Type & Invoice Number-->
    <div class="p-grid">

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Invoice Number
            </div>
            <div class="p-text-bold p-mt-1">
                <div class="p-d-flex p-ai-center">
                    <div class="p-text-secondary" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                        {{statement?.invoiceNumber ? statement?.invoiceNumber : '-'}}
                    </div>
                    <div class="p-ml-1 p-cursor p-text-secondary">
                        <img (click)="handleClickActions('view-document', statement)" class="p-cursor"
                             src="assets/branding/shared-icons/view.svg" alt=""
                             style="height: 1.3rem;">
                    </div>
                </div>
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Bill to
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.billToPartyName ? statement?.billToPartyName : '-'}}
            </div>
        </div>

    </div>

    <!--    Invoice Date & Booking Number-->
    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Transport Document
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.transportDocument ? statement?.transportDocument : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Invoice Date
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.invoiceDate ? (statement?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}
            </div>
        </div>
    </div>

    <!--    Customer Reference Number & Transport Document-->
    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Due Date
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.dueDate ? (statement?.dueDate | date: 'dd-MMM-yyyy') : '-'}}
            </div>
        </div>

        <div class="p-col-6" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Invoice Currency
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.invoiceCurrency ? statement?.invoiceCurrency : '-'}}
            </div>
        </div>
    </div>

    <!--    Bill To & Invoice Amount-->
    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Amount
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Transactional Amount
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-'}}
            </div>
        </div>
    </div>

    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Due
            </div>
            <div class="p-mt-1" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                {{statement?.formattedDueAmount ? statement?.formattedDueAmount : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Status
            </div>
            <div class="p-mt-1" [class]="statement?.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'">
                {{statement?.status ? statement?.status : '-'}}
            </div>
        </div>
    </div>
</div>
